import "./index.css";
import "./heroFix.css";
import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App";
import { initMetaPixel } from "./utils/metaPixel";

// Las imágenes están en Recursos de Impultienda: se abre la conexión y se pide el mockup del hero
// antes de armar la página, así baja en paralelo con el resto.
const IMG_HOST = "https://aekpgsbqjzqntlbucbts.supabase.co";
const HERO_IMG = IMG_HOST + "/storage/v1/object/public/store-resources/ca102a97-52cb-4aa3-835d-c01eb600a0b4/1792559388580_mockup-reconecta-d2ef844d.webp";
try {
  const pc = document.createElement("link");
  pc.rel = "preconnect";
  pc.href = IMG_HOST;
  document.head.appendChild(pc);
  const pl = document.createElement("link");
  pl.rel = "preload";
  pl.as = "image";
  pl.href = HERO_IMG;
  pl.setAttribute("fetchpriority", "high");
  document.head.appendChild(pl);
} catch (e) {
  console.error(e);
}
try {
  initMetaPixel();
} catch (e) {
  console.error(e);
}
const rootEl = document.getElementById("root");
if (rootEl) {
  ReactDOM.createRoot(rootEl).render(<App data-id="element-306" data-mp="1ajvl0r3rxrie" />);
}